import { Channel } from '../../types/channel'
import { UserBrief } from '../../types/users'
import ChannelListRowHeader from './ChannelListRowHeader'
import useStyles from './styles/channelList.styles'

interface ChannelListProps {
  channels?: Channel[] | undefined
  usersData?: UserBrief[] | undefined
  autoCompleteChannelsList?: any
  setUsers: React.Dispatch<React.SetStateAction<UserBrief[]>>
  users: UserBrief[]
}

const ChannelList: React.FC<ChannelListProps> = ({
  channels,
  usersData,
  autoCompleteChannelsList,
  setUsers,
  users
}) => {
  const classes = useStyles()

  const filterChannels = channels?.filter((ch) =>
    autoCompleteChannelsList
      .map((each: any) => each.value)
      .includes(ch.basicDetails.channelID)
  )

  return (
    <div className={classes.list}>
      {filterChannels &&
        filterChannels.map((filterChannelItem, index: number) => (
          <ChannelListRowHeader
            key={index}
            channel={filterChannelItem}
            filteredUserList={usersData
              ?.filter(
                (userList) =>
                  userList.displayEntityCode ===
                  filterChannelItem.basicDetails.displayChannelCode
              )
              .map((item: UserBrief) => ({
                ...item,
                checked:
                  users.findIndex((u) => u.ID === item.ID) > -1 ? true : false
              }))}
            setUsers={setUsers}
            users={users}
          />
        ))}
    </div>
  )
}

export default ChannelList
